// extracted by mini-css-extract-plugin
module.exports = {"layout-box":"index_layout-box__1ldXJ","no-layout":"index_no-layout__-KTNV"};